export const fr = {
  nav: {
    services: "Mandats",
    solutions: "Solutions",
    about: "La firme",
    insights: "Perspectives",
    contact: "Contact",
    talkToUs: "Parlons-en",
    seeWhatWeBuild: "Nos réalisations",
  },
  trustTicker: {
    builtFor: "Secteurs servis",
    items: ["Commerce de détail", "Biens de consommation", "Services professionnels", "Franchises", "Marques DTC"],
  },
  offerCard: {
    learnMore: "Détails du mandat",
  },
  cta: {
    talkToUs: "Parlons-en",
  },
  home: {
    heroLabel: "IA agentique · IA générative · IA prédictive · Plateformes de données",
    heroTitle: "On bâtit les systèmes IA qui font tourner votre entreprise.",
    heroSubtitle:
      "IA, infrastructure de données et systèmes décisionnels de calibre production.\nCadrés, construits et déployés par une seule équipe.",
    whyUsLabel: "Pourquoi Vert AI",
    whyUsTitle: "Une firme.\nDu cadrage à la production.",
    whyUsSubtitle:
      "Aucun transfert entre les gens qui pensent et ceux qui construisent. L'équipe qui définit l'opportunité est celle qui déploie le système.",
    diff1Title: "Une seule équipe, du cadrage au déploiement",
    diff1Desc:
      "La stratégie et l'ingénierie ne sont pas séparées. La même équipe définit la solution, conçoit l'architecture, écrit le code et met le système en production.",
    diff2Title: "Profondeur technique, jugement commercial",
    diff2Desc:
      "Science des données, ingénierie ML et architecture de systèmes IA, ancrées dans l'économie unitaire et des résultats mesurables. On construit des systèmes qui font bouger l'entreprise.",
    diff3Title: "Des systèmes en production, pas des prototypes",
    diff3Desc:
      "Chaque mandat livre un système qui opère à l'intérieur de votre entreprise. Monitoré, documenté, conçu pour rouler sans surveillance constante.",
    diff4Title: "Livrables garantis",
    diff4Desc:
      "Chaque mandat inclut un engagement de résultat défini. Si le périmètre convenu n'est pas livré, on continue sans frais professionnels jusqu'à livraison.",
    engagementsLabel: "Mandats",
    engagementsTitle: "Services",
    engagementsSubtitle:
      "Cadrés selon votre opportunité d'affaires. Tarifés selon la valeur attendue. Livrables définis. Garantie de résultat incluse.",
    offer1Title: "IA agentique",
    offer1Desc:
      "Automatiser les flux à forte valeur qui consomment votre capacité opérationnelle. Agents encadrés avec routage, contrôles, chemins de repli et supervision humaine, déployés de bout en bout.",
    offer2Title: "IA générative",
    offer2Desc:
      "Transformer le savoir institutionnel et les documents non structurés en réponses fiables. Systèmes ancrés par recherche avec attribution des sources, évaluation et seuils de précision sur lesquels vos équipes peuvent s'appuyer.",
    offer3Title: "IA prédictive",
    offer3Desc:
      "Quantifier ce qui anime le revenu, la rétention et la marge. Modèles de production pour l'attrition, la valeur client, la demande, la recommandation, la propension et la rentabilité, déployés dans les flux où les décisions se prennent.",
    offer4Title: "Plateformes de données",
    offer4Desc:
      "Bâtir la fondation de données dont dépendent votre IA et vos analyses. Architecture source de vérité, couche sémantique, contrôles de qualité et instrumentation de préparation IA conçues pour la confiance.",
    domainsLabel: "Ce qu'on construit",
    domainsTitle: "Les systèmes qu'on déploie.\n",
    domainsSubtitle:
      "Systèmes IA, données et décision de calibre production pour les flux que les logiciels standards ne couvrent pas pleinement.",
    domain1Label: "Agents IA et automatisation de flux",
    domain1Desc:
      "Réduire le coût manuel des opérations, de la finance et de l'exécution interne. Agents encadrés avec logique de routage, contrôles, chemins de repli et révision humaine aux points qui comptent.",
    domain2Label: "Service client et systèmes de soutien",
    domain2Desc:
      "Augmenter la vitesse de résolution et contenir le coût par billet sans sacrifier la qualité. Classification d'intention, réponses ancrées dans le savoir, assistance aux agents et escalade selon le niveau de confiance.",
    domain3Label: "Gestion du savoir et recherche d'entreprise",
    domain3Desc:
      "Récupérer les heures perdues à chercher des réponses. Assistants augmentés par recherche qui raisonnent sur les politiques, procédures, données produit et documentation commerciale, avec attribution des sources.",
    domain4Label: "Intelligence documentaire",
    domain4Desc:
      "Convertir les documents non structurés en données structurées fiables. Extraction, classification, validation et scoring de confiance sur les contrats, propositions, factures et appels d'offres.",
    domain5Label: "Modèles prédictifs et science décisionnelle",
    domain5Desc:
      "Faire passer les décisions commerciales de l'instinct au signal scoré. Modèles de production pour l'attrition, la valeur client, le scoring de prospects, la prévision de demande et la priorisation, déployés dans les flux où l'action se prend.",
    domain6Label: "Recommandation et personnalisation",
    domain6Desc:
      "Augmenter la conversion, le panier moyen et le revenu sur le cycle de vie. Moteurs de recommandation et logique de prochaine meilleure action pour le commerce en ligne, le merchandising et l'expérience client.",
    domain7Label: "Décision de rentabilité et de croissance",
    domain7Desc:
      "Allouer le capital sur le profit réel, pas sur les métriques de plateforme. Systèmes de mesure et de modélisation reliant canal, cohorte, marge de contribution et délai de récupération.",
    domain8Label: "Plateformes de données pour l'IA",
    domain8Desc:
      "Donner à chaque modèle et chaque tableau de bord la même version de la vérité. Architecture source de vérité, couche sémantique, assurance qualité et instrumentation conçues pour la confiance et la traçabilité.",
    domain9Label: "Opérations IA, évaluation et contrôle",
    domain9Desc:
      "Garder l'IA de production sûre, observable et en amélioration. Monitoring, harnais d'évaluation, standards de prompts, contrôles humain-dans-la-boucle, logique d'escalade et garde-fous opérationnels.",
    founderLabel: "Le fondateur",
    founderName: "Guillaume Belisle",
    founderRole: "Fondateur, Vert AI",
    founderP1:
      "Scientifique des données, ingénieur ML et constructeur de systèmes IA. Guillaume a conçu et déployé des systèmes IA, ML et données de production pour Louis Vuitton, Canada Goose, Lowe's, Home Hardware et d'autres organisations où une implantation ratée a des conséquences financières réelles.",
    founderP2:
      "Il a fondé Vert AI parce que l'industrie sépare systématiquement les gens qui pensent de ceux qui construisent. Pas chez nous. La même personne qui cadre le problème conçoit l'architecture, écrit le code et le met en production.",
    founderP3: "Un seul interlocuteur. Aucune couche intermédiaire. Aucun sous-traitant.",
    founderTags: ["Systèmes IA", "Ingénierie de données", "ML / Science des données", "Systèmes décisionnels", "Mesure de rentabilité"],
    insightsLabel: "Perspectives",
    insightsTitle: "Des idées qui se rendent en production.",
    allInsights: "Toutes les perspectives",
    insightRead: "Lire",
    insight1Cat: "Systèmes IA",
    insight1Title: "95 % des projets IA d'entreprise échouent en production. Le modèle n'a jamais été en cause.",
    insight1Desc:
      "Gartner, le MIT et chaque sondage d'entreprise convergent. Le goulot, c'est l'ingénierie, l'architecture de données et la préparation opérationnelle, pas le choix du modèle.",
    insight2Cat: "Ingénierie de données",
    insight2Title: "La couche sémantique est l'actif le plus sous-estimé en IA d'entreprise.",
    insight2Desc:
      "À peine 7 % des entreprises opèrent une fondation sémantique gouvernée. Sans elle, chaque modèle et chaque tableau de bord s'entraîne sur une version différente de la vérité.",
    insight3Cat: "Science décisionnelle",
    insight3Title: "Vos indicateurs de croissance mentent. Voici quoi mesurer à la place.",
    insight3Desc:
      "Le revenu brut est de la vanité. Le ROAS est une fiction de plateforme. Le CAC ignore la dégradation des cohortes. La plupart des cadres de mesure récompensent en silence la destruction de capital.",
    faqLabel: "Questions fréquentes",
    faqTitle: "Des réponses directes.",
    faq1Q: "Stratégie ou implémentation?",
    faq1A:
      "Les deux, par conception. On cadre le problème, on conçoit l'architecture, on construit et on déploie. Une seule équipe, du début à la fin. Aucun transfert entre les gens qui pensent et ceux qui construisent.",
    faq2Q: "Que veut dire « calibre production »?",
    faq2A:
      "Le système opère à l'intérieur de votre entreprise. Pas dans un notebook. Pas dans un environnement de démo. Déployé, monitoré, documenté et transféré avec procédures opérationnelles et propriété claire.",
    faq3Q: "En quoi Vert AI se distingue des autres firmes IA?",
    faq3A:
      "Profondeur technique et jugement commercial dans une seule équipe. On ne construit pas de la technologie pour elle-même. On construit des systèmes conçus autour de résultats d'affaires mesurables, avec livrables garantis.",
    faq4Q: "Avec quel type d'entreprise travaillez-vous?",
    faq4A:
      "PDG, COO, CFO et responsables données dans des entreprises de marché intermédiaire. Détail, commerce en ligne, services professionnels, opérateurs de franchises et entreprises en croissance. Des opérateurs qui veulent des systèmes déployés, pas du théâtre IA.",
    faq5Q: "Comment sont tarifés les mandats?",
    faq5A:
      "Cadrés selon le problème. Tarifés selon la valeur attendue. Chaque mandat a des livrables définis, un échéancier ferme et une garantie de résultat concrète. Aucun forfait. Aucun énoncé de travail ouvert.",
    faq6Q: "Offrez-vous du support après la mise en service?",
    faq6A:
      "Oui. La Cadence opérationnelle couvre le raffinement, le réentraînement, l'évaluation, l'ajustement de performance et l'expansion de la feuille de route, sur une base récurrente.",
    ctaHeadline: "La prochaine étape, c'est une conversation.",
    ctaDescription:
      "Décrivez le problème. On vous dit ce qu'on construirait, le temps requis et le coût. Aucun deck. Aucune phase de découverte. Une conversation directe.",
  },
  services: {
    heroLabel: "Mandats",
    heroTitle: "Quatre piliers. Des systèmes en production.",
    heroSubtitle:
      "Chaque mandat cible un problème d'affaires précis dans un de quatre piliers IA. Livrables définis. Garantie de résultat. Une équipe du cadrage à la production.",
    coreLabel: "Les quatre piliers",
    offer1Title: "IA agentique",
    offer1Desc:
      "Systèmes autonomes encadrés pour les opérations, le support, la finance et l'exécution interne. Routage, contrôles, chemins de repli et révision humaine aux points qui comptent.",
    offer2Title: "IA générative",
    offer2Desc:
      "Systèmes augmentés par recherche qui raisonnent sur le savoir institutionnel et les documents non structurés. Sorties ancrées, attribution des sources et précision de calibre production.",
    offer3Title: "IA prédictive",
    offer3Desc:
      "Modèles de production qui scorent, classent, prévoient et quantifient la vérité économique. Attrition, valeur client, demande, recommandation, propension et rentabilité, déployés dans vos flux.",
    offer4Title: "Plateformes de données",
    offer4Desc:
      "L'architecture, la couche sémantique, les contrôles de qualité et la fondation de préparation IA requises avant que l'IA, les analyses ou les systèmes décisionnels puissent opérer de façon fiable.",
    howToChooseLabel: "Par où commencer",
    howToChooseTitle: "Partez du problème.",
    choose1Offer: "IA agentique",
    choose1Situation:
      "Un flux à forte valeur consomme votre capacité opérationnelle, et il vous faut un partenaire capable de le cadrer, de bâtir le système d'agent et de le déployer avec les bons contrôles et la bonne conception humain-dans-la-boucle.",
    choose1Start: "Commencer ici pour les flux autonomes.",
    choose2Offer: "IA générative",
    choose2Situation:
      "Vos équipes perdent des heures dans les politiques, procédures, contrats et documents. Il vous faut un système IA qui raisonne sur le savoir institutionnel et retourne des réponses ancrées et attribuables sur lesquelles vos équipes peuvent agir.",
    choose2Start: "Commencer ici pour le savoir et les documents.",
    choose3Offer: "IA prédictive",
    choose3Situation:
      "Les décisions commerciales se prennent à l'instinct. Il vous faut du scoring, de la prévision, de la recommandation ou des modèles de rentabilité déployés dans les flux où l'attrition, la valeur client, la demande et l'allocation de capital se décident.",
    choose3Start: "Commencer ici pour les modèles prédictifs.",
    choose4Offer: "Plateformes de données",
    choose4Situation:
      "Les rapports donnent des réponses différentes selon qui les produit. Les initiatives IA bloquent parce que la fondation est fragmentée, incohérente ou peu fiable. La couche de données doit être reconstruite pour la confiance.",
    choose4Start: "Commencer ici pour l'infrastructure de données.",
    processLabel: "Notre façon de travailler",
    processTitle: "Du problème à la production.",
    step1Title: "Cadrage",
    step1Desc:
      "Définir le problème. Identifier le bon pilier. S'entendre sur les livrables, les critères de succès et l'échéancier.",
    step2Title: "Architecture",
    step2Desc:
      "Conception du système, flux de données, plan d'intégration et chemin de déploiement. Avant la moindre ligne de code.",
    step3Title: "Construction",
    step3Desc:
      "Implémentation contre des points de contrôle définis. Travail sur les données, développement de modèles et de systèmes, évaluation, assurance qualité et itération.",
    step4Title: "Déploiement",
    step4Desc:
      "Mise en production, documentation, habilitation de l'équipe, mise en place du monitoring et transfert opérationnel.",
    domainsLabel: "Domaines d'implémentation",
    domainsTitle: "Les solutions que ces mandats livrent.",
    domainsSubtitle:
      "Chaque pilier construit des systèmes IA, données et décision spécifiques à l'intérieur de l'entreprise. Voici les domaines d'implémentation où on opère.",
    domainsGroup1: "IA agentique",
    domainsGroup2: "IA générative",
    domainsGroup3: "IA prédictive",
    domainsGroup4: "Plateformes de données",
    domainsGroupCross: "Transversal · Post-lancement",
    domain1: "Agents IA et automatisation de flux",
    domain2: "Service client et systèmes de soutien",
    domain3: "Gestion du savoir et recherche d'entreprise",
    domain4: "Intelligence documentaire",
    domain5: "Modèles prédictifs et science décisionnelle",
    domain6: "Recommandation et personnalisation",
    domain7: "Décision de rentabilité et de croissance",
    domain8: "Plateformes de données pour l'IA",
    domain9: "Opérations IA, évaluation et contrôle",
    supportLabel: "Après la construction",
    supportTitle: "Support continu.",
    support1Title: "Couche opérateur IA",
    support1Desc:
      "Les contrôles qui gardent les systèmes IA utilisables, monitorés et sûrs en production. Contrôles d'accès, conception humain-dans-la-boucle, règles d'évaluation, logique d'escalade, monitoring et procédures opérationnelles.",
    support2Title: "Cadence opérationnelle",
    support2Desc:
      "Raffinement post-lancement, réentraînement, évaluation, ajustement de performance et expansion de la feuille de route. Offert en niveaux Essentiel, Avancé et Élite avec revues mensuelles.",
    ctaHeadline: "Décrivez le problème.",
    ctaDesc:
      "Aucun deck requis. Aucun engagement. Décrivez le problème à résoudre et on vous dira exactement ce qu'on construirait.",
  },
  agenticAI: {
    backLink: "← Mandats",
    duration: "4 à 14 semaines",
    heroTitle: "IA agentique",
    heroSubtitle:
      "Automatiser les flux à forte valeur qui consomment votre capacité opérationnelle. Systèmes d'agents encadrés avec routage, contrôles, chemins de repli et supervision humaine, déployés de bout en bout.",
    heroTimeline: "Agent ciblé : 4–6 sem. · Flux intégré : 6–10 sem. · Système multi-agents : 10–14 sem.",
    problemLabel: "Le problème",
    problemP1:
      "La majorité des démos d'agents s'effondrent au premier contact avec les vrais systèmes, les vraies exceptions et la vraie reddition de comptes. L'écart entre un agent qui roule dans un bac à sable et un agent qui opère en sécurité dans une entreprise est un problème d'ingénierie, de gouvernance et de conception humain-dans-la-boucle, pas une limite du modèle.",
    problemP2:
      "Ce mandat comble cet écart. Autonomie encadrée. Contrôles réels. Déploiement en production. Résultat garanti.",
    buyersLabel: "Pour qui",
    buyers: [
      "COO ou directeur des opérations dont les flux manuels ne passent pas l'échelle",
      "CFO ou responsable finance qui automatise routage, validation et gestion d'exceptions",
      "Responsable de l'expérience client qui a besoin de triage et résolution intelligents à fort volume",
      "Leader fonctionnel qui passe de la démo d'agent au système déployé et gouverné",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers la production.",
    phases: [
      {
        num: "01",
        title: "Cadrer le flux et l'économie",
        desc: "Sélection du flux, définition des limites d'autonomie, justification économique, critères de succès et cartographie des responsabilités. Livrable : une note d'une page sur le flux et les critères d'acceptation.",
      },
      {
        num: "02",
        title: "Concevoir l'architecture de l'agent",
        desc: "Conception complète du système : logique de routage, sélection d'outils et d'intégrations, limites de contrôle, chemins de repli et points humain-dans-la-boucle. Livrable : un diagramme d'architecture et un inventaire des outils.",
      },
      {
        num: "03",
        title: "Construire l'orchestration",
        desc: "Câblage des outils, conception des prompts et de l'orchestration, règles d'affaires, gestion des exceptions, logique d'escalade et garde-fous opérationnels. Livrable : un agent fonctionnel sur le périmètre convenu.",
      },
      {
        num: "04",
        title: "Évaluer et durcir",
        desc: "Cas de test, analyse des modes de défaillance, scoring comportemental, critères d'acceptation d'affaires et seuils de fiabilité pour le comportement autonome. Livrable : un rapport d'évaluation et une approbation de fiabilité.",
      },
      {
        num: "05",
        title: "Déployer en production",
        desc: "Mise en production, accès et permissions, exigences de monitoring, pistes d'audit, transfert opérationnel et documentation complète. Livrable : un système en exploitation avec monitoring en place.",
      },
      {
        num: "06",
        title: "Gouverner et faire adopter",
        desc: "Guide utilisateur, procédures opérationnelles, manuels d'escalade et règles de gouvernance pour une opération autonome sûre et durable. Livrable : un manuel d'adoption et un cadre de gouvernance.",
      },
    ],
    useCasesLabel: "Cas d'utilisation courants",
    useCases: [
      "Automatisation de flux opérationnels",
      "Triage et résolution en service client",
      "Routage de demandes internes",
      "Automatisation finance et approvisionnement",
      "Copilotes ventes et opérations",
      "Vérification de conformité et validation",
      "Orchestration multi-étapes avec révision humaine",
      "Flux hybrides règles et LLM",
      "Gestion d'exceptions et escalade",
      "Systèmes multi-agents encadrés",
    ],
    guaranteeLabel: "Garantie",
    guaranteeTitle: "Garantie d'agent en production",
    guaranteeDesc:
      "Si Vert AI ne livre pas une conception complète d'agent, une implémentation fonctionnelle pour le périmètre convenu et un chemin de déploiement clair avec contrôles opérationnels, on continue sans frais professionnels jusqu'à livraison.",
    ctaHeadline: "Décrivez le flux.",
    ctaDesc: "On cadrera le système d'agent, les contrôles et le chemin de déploiement.",
  },
  generativeAI: {
    backLink: "← Mandats",
    duration: "4 à 12 semaines",
    heroTitle: "IA générative",
    heroSubtitle:
      "Transformer le savoir institutionnel et les documents non structurés en réponses fiables. Systèmes ancrés par recherche avec attribution des sources, harnais d'évaluation et seuils de précision conçus pour la production.",
    heroTimeline: "Construction ciblée : 4–6 sem. · Multi-source : 6–9 sem. · Déploiement entreprise : 9–12 sem.",
    problemLabel: "Le problème",
    problemP1:
      "L'IA générative sans ancrage est une responsabilité. Réponses hallucinées, citations manquantes et extraction peu fiable depuis les documents ont tué plus de pilotes d'entreprise que toute limite technique. Les systèmes qui fonctionnent sont bâtis sur des architectures de recherche qui ancrent chaque réponse à une source vérifiable et qui sont évalués selon des standards de précision d'affaires, pas des bancs d'essai génériques.",
    problemP2:
      "Ce mandat construit ces systèmes. Ancrés par recherche. Sources attribuées. Évalués pour la production.",
    buyersLabel: "Pour qui",
    buyers: [
      "Responsable des opérations dont les équipes perdent des heures dans les politiques, procédures et données produit",
      "Leader juridique, finance ou approvisionnement qui traite de gros volumes de contrats et de documents",
      "Responsable de l'expérience client qui a besoin d'assistance ancrée et attribuable pour les agents",
      "Leader savoir ou apprentissage qui bâtit des assistants internes pour le personnel",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers des systèmes ancrés.",
    phases: [
      {
        num: "01",
        title: "Cadrer le cas d'usage et cartographier les sources",
        desc: "Périmètre savoir ou documentaire défini, inventaire des sources, cibles de précision, stratégie de recherche et cartographie des responsabilités. Livrable : une carte des sources et une spécification de précision.",
      },
      {
        num: "02",
        title: "Concevoir l'architecture de recherche",
        desc: "Conception d'ingestion, stratégie de découpage et d'embeddings, logique de recherche et reranking, règles d'ancrage et modèle d'attribution des sources. Livrable : une architecture de recherche et un plan d'évaluation.",
      },
      {
        num: "03",
        title: "Concevoir la génération et le raisonnement",
        desc: "Structure de prompts et de raisonnement, exigence de citation, gestion du refus et de l'incertitude, schémas de sortie et logique de validation. Livrable : une couche de génération fonctionnelle avec citation imposée.",
      },
      {
        num: "04",
        title: "Évaluer la précision et les citations",
        desc: "Évaluation par jeu de référence, scoring de précision et de citation, analyse des modes de défaillance, seuils d'acceptation d'affaires et conception de rétroaction continue. Livrable : un harnais d'évaluation et une approbation de précision.",
      },
      {
        num: "05",
        title: "Déployer en production",
        desc: "Mise en production, contrôles d'accès, monitoring de dérive et de précision, transfert opérationnel et documentation complète. Livrable : un système en exploitation avec monitoring de dérive en place.",
      },
      {
        num: "06",
        title: "Adopter et améliorer en continu",
        desc: "Guide utilisateur, rapport de lacunes de contenu, boucles de rétroaction et cadence de maintenance pour les sources de savoir sous-jacentes. Livrable : une boucle d'amélioration et un modèle de propriété de contenu.",
      },
    ],
    useCasesLabel: "Cas d'utilisation courants",
    useCases: [
      "Assistants de savoir interne",
      "Recherche de politiques et procédures",
      "Extraction de contrats et de clauses",
      "Traitement de factures et de documents",
      "Génération de réponses aux appels d'offres",
      "Assistants ventes et savoir produit",
      "Revue documentaire de conformité",
      "Systèmes de savoir pour le support technique",
      "Recherche entreprise multi-source",
      "Interfaces conversationnelles sur données privées",
    ],
    guaranteeLabel: "Garantie",
    guaranteeTitle: "Garantie de sortie ancrée",
    guaranteeDesc:
      "Si Vert AI ne livre pas un système fonctionnel de recherche et de génération qui atteint les standards convenus de précision et de citation, on continue sans frais professionnels jusqu'à livraison.",
    ctaHeadline: "Montrez-nous le problème de savoir.",
    ctaDesc: "On cadrera le système de recherche, les cibles de précision et le chemin de déploiement.",
  },
  predictiveAI: {
    backLink: "← Mandats",
    duration: "4 à 14 semaines",
    heroTitle: "IA prédictive",
    heroSubtitle:
      "Quantifier ce qui anime le revenu, la rétention et la marge, et placer ce signal là où les décisions se prennent. Modèles de production pour l'attrition, la valeur client, la demande, la recommandation, la propension et la rentabilité, déployés de bout en bout.",
    heroTimeline: "Modèle ciblé : 4–6 sem. · Système multi-modèle : 6–10 sem. · Déploiement production : 10–14 sem.",
    problemLabel: "Le problème",
    problemP1:
      "La majorité des analyses reste descriptive. Les entreprises investissent dans des couches de rapports mais ne construisent jamais les systèmes prédictifs qui améliorent les décisions générant le revenu, la marge et la croissance. Les modèles existants vivent dans des notebooks, n'atteignent jamais les flux où l'action se prend et ne sont jamais évalués selon les résultats d'affaires.",
    problemP2:
      "Ce mandat construit des modèles qui mènent à l'action. Scorés, déployés et connectés aux décisions qui composent le profit.",
    buyersLabel: "Pour qui",
    buyers: [
      "PDG ou fondateur qui a besoin d'une intelligence commerciale plus fine pour guider l'allocation de capital et la croissance",
      "CFO ou CMO qui dimensionne attrition, valeur client, délai de récupération et mix de canaux",
      "VP Croissance ou responsable science des données qui a besoin de modèles de production, pas de notebooks",
      "Leader merchandising, commerce en ligne ou opérations qui optimise des décisions à fort volume",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers l'utilité décisionnelle.",
    phases: [
      {
        num: "01",
        title: "Cadrer la décision et l'économie",
        desc: "Décision cible définie, métrique de succès établie, valeur économique cadrée et cas d'usage sélectionné. Inclut les cadrages de rentabilité et d'allocation de capital lorsque pertinents. Livrable : une note décisionnelle d'une page.",
      },
      {
        num: "02",
        title: "Concevoir le modèle et les variables",
        desc: "Sélection de l'approche de modélisation, ingénierie des variables, conception d'étiquetage, stratégie de validation et compromis précision contre utilisabilité. Livrable : une spécification de variables et un plan de validation.",
      },
      {
        num: "03",
        title: "Entraîner et évaluer",
        desc: "Cadre d'entraînement et de validation, évaluation de performance, vérifications de pertinence d'affaires, logique de seuils et de segmentation, analyse d'erreurs. Livrable : un modèle validé avec performance documentée.",
      },
      {
        num: "04",
        title: "Concevoir le déploiement",
        desc: "Logique de scoring, patron d'utilisation en production, transfert vers le flux ou la couche décisionnelle, calendrier de réentraînement et monitoring. Livrable : une conception de déploiement avec cadence de réentraînement.",
      },
      {
        num: "05",
        title: "Traduire en interprétation d'affaires",
        desc: "Sens des scores, cadre d'action, guide d'utilisation en aval, mises en garde et notes de fiabilité pour les opérateurs. Livrable : un manuel score-vers-action.",
      },
      {
        num: "06",
        title: "Intégrer à la couche décisionnelle",
        desc: "Connexion au flux, tableau de bord ou manuel où le score est actionné. Pour la rentabilité, inclut la logique de recommandation couper, augmenter ou corriger. Livrable : un système décisionnel en exploitation dans le flux.",
      },
    ],
    useCasesLabel: "Cas d'utilisation courants",
    useCases: [
      "Prédiction d'attrition et intervention",
      "Modélisation de la valeur client",
      "Scoring de prospects et de comptes",
      "Prévision de demande et d'inventaire",
      "Recommandation et prochaine meilleure action",
      "Modèles de propension et segmentation",
      "Support de prix et d'assortiment",
      "Rentabilité et économie par cohorte",
      "Mesure de canal et de délai de récupération",
      "Classification et priorisation opérationnelle",
    ],
    guaranteeLabel: "Garantie",
    guaranteeTitle: "Garantie d'utilité décisionnelle",
    guaranteeDesc:
      "Si Vert AI ne livre pas un modèle ou système de scoring validé, une interprétation d'affaires claire et une conception de déploiement qui connecte la sortie à une vraie décision, on continue sans frais professionnels jusqu'à livraison.",
    ctaHeadline: "Nommez la décision.",
    ctaDesc: "On cadrera le modèle, les exigences de données et le chemin de déploiement.",
  },
  dataPlatforms: {
    backLink: "← Mandats",
    duration: "4 à 14 semaines",
    heroTitle: "Plateformes de données",
    heroSubtitle:
      "Bâtir la fondation de données dont dépendent votre IA et vos analyses. Architecture source de vérité, couche sémantique, contrôles de qualité et instrumentation de préparation IA, conçues pour la confiance et la traçabilité.",
    heroTimeline: "Ciblé : 4–6 sem. · Multi-source : 6–10 sem. · Environnement élargi : 10–14 sem.",
    problemLabel: "Le problème",
    problemP1:
      "Les investissements en IA et en analyses s'effondrent quand les données sous-jacentes sont fragmentées, incohérentes ou peu fiables. Les modèles entraînés sur des données déficientes produisent des décisions déficientes. Les systèmes génératifs récupèrent le mauvais contexte. Les modèles prédictifs s'entraînent sur des variables brisées. Les rapports donnent des réponses différentes selon qui les produit.",
    problemP2:
      "Ce mandat construit la couche de confiance dont dépendent votre IA, vos analyses et votre pile décisionnelle.",
    buyersLabel: "Pour qui",
    buyers: [
      "COO ou CFO qui a besoin de rapports fiables et de données de calibre décisionnel",
      "Responsable données ou leader analytique en charge de la qualité et de la fiabilité des données",
      "Leader RevOps ou Marketing Ops avec des lacunes de mesure qu'il ne peut pas combler",
      "Responsable technique qui prépare l'infrastructure pour le déploiement IA, ML ou génératif",
    ],
    processLabel: "Le processus",
    processTitle: "Six phases vers des données de calibre décisionnel.",
    phases: [
      {
        num: "01",
        title: "Cartographier l'architecture et les sources",
        desc: "Inventaire des systèmes sources, architecture cible, conception source de vérité, cartographie des entités et structure de propriété. Livrable : une carte des sources et un diagramme d'architecture cible.",
      },
      {
        num: "02",
        title: "Modéliser les données et la couche sémantique",
        desc: "Modèles de données principaux, logique sémantique, définitions de métriques, plan de transformation et implémentation des règles d'affaires. Livrable : des modèles de données implémentés et un dictionnaire de métriques.",
      },
      {
        num: "03",
        title: "Implémenter les contrôles de qualité et de confiance",
        desc: "Vérifications d'assurance qualité, règles de réconciliation, nettoyage taxonomique, logique d'identité et de déduplication, et remédiation des écarts de confiance. Livrable : une suite de tests qualité et des rapports de réconciliation.",
      },
      {
        num: "04",
        title: "Instrumenter la couche événementielle",
        desc: "Conception de la couche événementielle, capture des étapes de processus, suivi des transferts, journalisation des exceptions et traçabilité. Livrable : un schéma d'événements et l'instrumentation en production.",
      },
      {
        num: "05",
        title: "Préparer la couche IA et ML",
        desc: "Disponibilité des variables, préparation à la recherche pour les systèmes génératifs, classification calibre décisionnel contre directionnel et identification des blocages en amont. Livrable : une évaluation de préparation IA et un catalogue de variables.",
      },
      {
        num: "06",
        title: "Documenter et transférer",
        desc: "Dictionnaire de KPIs, documentation de la logique, notes d'architecture, guide de maintenance et feuille de route pour les systèmes IA en aval. Livrable : un dossier de documentation et une feuille de route en aval.",
      },
    ],
    useCasesLabel: "Problèmes courants qu'on résout",
    useCases: [
      "Systèmes sources déconnectés",
      "Logique de KPIs incohérente entre les équipes",
      "Structure source de vérité fragile",
      "Faible disponibilité de variables pour ML et IA",
      "Confiance brisée envers les rapports",
      "Instrumentation et capture d'événements manquantes",
      "Données d'entrée peu fiables pour les modèles",
      "Aucun modèle de données prêt pour la production",
      "Lacunes de recherche pour les systèmes génératifs",
    ],
    guaranteeLabel: "Garantie",
    guaranteeTitle: "Garantie de données de calibre décisionnel",
    guaranteeDesc:
      "Si le périmètre convenu ne produit pas une structure source de vérité documentée, une logique de données principale implémentée et une couche de confiance et d'assurance qualité utilisable, Vert AI continue sans frais professionnels jusqu'à livraison.",
    ctaHeadline: "Commencez par les données.",
    ctaDesc: "Décrivez votre environnement de données. On cadrera l'architecture et le chemin vers la fiabilité.",
  },
  about: {
    heroLabel: "La firme",
    heroTitle: "On existe parce que la plupart des firmes ne peuvent pas construire ce qu'elles recommandent.",
    heroSubtitle:
      "Vert AI est une firme canadienne d'IA et d'ingénierie de données. On conçoit, construit et déploie des systèmes de production pour les opérateurs qui mesurent le succès en capacité déployée, pas en présentations.",
    beliefsLabel: "Nos convictions",
    beliefs: [
      "L'exécution est le goulot. Pas l'IA.",
      "La stratégie sans ingénierie, c'est du bruit.",
      "De meilleurs systèmes produisent de meilleures décisions.",
      "La confiance dans les données précède l'échelle.",
      "Un système déployé est le seul livrable qui compte.",
    ],
    approachLabel: "Notre approche",
    approachTitle: "Profondeur technique.\nClarté commerciale.\nFocus production.",
    approachP1:
      "On travaille avec les équipes de direction sur les problèmes qui déterminent si les investissements en IA et en données produisent de la valeur mesurable ou deviennent des frais récurrents.",
    approachP2:
      "Chaque mandat commence par le cas d'affaires, pas par la technologie. On conçoit autour des gains opérationnels, de l'économie unitaire et de résultats qu'on peut mesurer. On cadre, on conçoit l'architecture, on construit, on déploie. Une seule équipe, du début à la fin.",
    approachP3:
      "Mandats structurés. Livrables définis. Résultats garantis. Aucun forfait. Aucune ambiguïté.",
    founderLabel: "Le fondateur",
    founderName: "Guillaume Belisle",
    founderRole: "Fondateur, Vert AI",
    founderP1:
      "Scientifique des données, ingénieur ML et constructeur de systèmes IA. Guillaume a conçu et déployé des systèmes IA, ML et données de production pour Louis Vuitton, Canada Goose, Lowe's, Home Hardware et d'autres organisations où une implantation ratée a des conséquences financières réelles.",
    founderP2:
      "Il a fondé Vert AI parce que l'industrie sépare systématiquement les gens qui pensent de ceux qui construisent. Pas chez nous. La même personne qui cadre le problème conçoit l'architecture, écrit le code et le met en production.",
    founderP3: "Un seul interlocuteur. Aucune couche intermédiaire. Aucun sous-traitant.",
    founderTags: ["Systèmes IA", "Ingénierie de données", "ML / Science des données", "Systèmes décisionnels", "Mesure de rentabilité"],
    ctaHeadline: "Parlons de votre enjeu.",
    ctaDesc: "On cadrera le système, l'échéancier et les livrables.",
  },
  insights: {
    heroLabel: "Perspectives",
    heroTitle: "Des idées qui se rendent en production.",
    heroSubtitle:
      "Analyses orientées implémentation sur les systèmes IA, l'infrastructure de données et l'économie de la décision commerciale.",
    featured: "À la une",
    readArticle: "Lire l'article",
    articles: [
      {
        cat: "Systèmes IA",
        title: "Le déficit d'évaluation : pourquoi la plupart des systèmes IA n'ont aucun tableau de bord honnête.",
        desc: "Le score F1, le BLEU et la satisfaction utilisateur ne sont pas des indicateurs commerciaux. L'architecture d'évaluation en quatre couches, hors ligne, en miroir, déploiement contrôlé et dérive en production, qui sépare les démos des systèmes que la direction peut défendre au conseil.",
        date: "Avril 2026",
        readTime: "8 min de lecture",
      },
      {
        cat: "Systèmes IA",
        title: "Construire ou acheter en IA. Le cadre décisionnel 2026.",
        desc: "Les modèles de fondation sont devenus des commodités. L'orchestration est le vrai facteur différenciant. Un modèle décisionnel à trois axes, levier des données propriétaires, spécificité du flux de travail et horizon de défense, pour arbitrer entre SaaS IA, assemblage et systèmes sur mesure.",
        date: "Mars 2026",
        readTime: "7 min de lecture",
      },
      {
        cat: "Systèmes IA",
        title: "95 % des projets IA d'entreprise échouent en production. Le modèle n'a jamais été en cause.",
        desc: "Gartner, le MIT et chaque sondage d'entreprise convergent. Le goulot, c'est l'ingénierie, l'architecture de données et la préparation opérationnelle, pas le choix du modèle. Ce que les équipes orientées implémentation font autrement.",
        date: "Mars 2026",
        readTime: "8 min de lecture",
      },
      {
        cat: "Ingénierie de données",
        title: "La couche sémantique est l'actif le plus sous-estimé en IA d'entreprise.",
        desc: "À peine 7 % des entreprises opèrent une fondation sémantique gouvernée. Sans elle, chaque modèle et chaque tableau de bord s'entraîne sur une version différente de la vérité. Pourquoi la couche sémantique est l'investissement d'infrastructure au meilleur rendement que la plupart des équipes données contournent.",
        date: "Février 2026",
        readTime: "7 min de lecture",
      },
      {
        cat: "Science décisionnelle",
        title: "Vos indicateurs de croissance mentent. Voici quoi mesurer à la place.",
        desc: "Le revenu brut est de la vanité. Le ROAS est une fiction de plateforme. Le CAC ignore la dégradation des cohortes. La plupart des cadres de mesure récompensent en silence la destruction de capital. Une approche de science décisionnelle pour mesurer ce qui compose réellement.",
        date: "Janvier 2026",
        readTime: "6 min de lecture",
      },
      {
        cat: "Systèmes IA",
        title:
          "L'IA agentique en production. Pourquoi la majorité des déploiements d'entreprise échoueront d'ici 2027.",
        desc: "Gartner prédit que 40 % des applications d'entreprise intégreront l'IA agentique d'ici fin 2026. La plupart ne survivront pas au contact des données de production. Les lacunes de gouvernance, d'évaluation et d'opérations qui séparent les démos des systèmes déployés.",
        date: "Décembre 2025",
        readTime: "9 min de lecture",
      },
      {
        cat: "Ingénierie de données",
        title: "Vos données ne sont pas prêtes pour l'IA. Cinq signaux diagnostiques.",
        desc: "Avant d'investir dans les modèles, faites passer ce diagnostic. Cinq signaux structurels, de la fragilité des pipelines à la dérive sémantique, qui prédisent si votre couche de données va propulser l'IA ou la saboter.",
        date: "Novembre 2025",
        readTime: "5 min de lecture",
      },
      {
        cat: "Intelligence de rentabilité",
        title:
          "La couche de coûts invisible. Pourquoi les calculs de ROI de l'IA ratent 40 à 60 % des dépenses réelles.",
        desc: "Gestion du changement, préparation des données, intégration et frais opérationnels comptent pour jusqu'à 60 % de l'investissement total en IA. Presque rien n'apparaît dans le dossier d'affaires. Comment construire un modèle de coûts honnête.",
        date: "Octobre 2025",
        readTime: "7 min de lecture",
      },
      {
        cat: "Systèmes IA",
        title: "L'écart entre un modèle entraîné et un système de production est un problème d'ingénierie.",
        desc: "Un modèle dans un notebook n'est pas un système. Monitoring, versionnage, logique de repli et échafaudage opérationnel séparent une démo d'une capacité déployée. La plupart des équipes ML ne sont pas outillées pour combler cet écart.",
        date: "Septembre 2025",
        readTime: "6 min de lecture",
      },
      {
        cat: "Science décisionnelle",
        title: "Couches décisionnelles. L'architecture manquante entre les données et l'action.",
        desc: "La plupart des entreprises ont des tableaux de bord. Très peu ont des systèmes décisionnels. Le patron architectural qui relie modèles prédictifs, règles d'affaires et flux opérationnels en systèmes qui génèrent de l'action, pas des rapports.",
        date: "Août 2025",
        readTime: "7 min de lecture",
      },
      {
        cat: "Ingénierie de données",
        title: "De l'ETL au stack IA-natif. Le vrai visage de l'infrastructure données en 2026.",
        desc: "Le modern data stack est mort. Le stack données IA-natif, temps réel, riche en contexte et gouverné sémantiquement, est ce que l'IA de production exige. Un plan architectural pour les équipes données qui construisent pour les systèmes agentiques.",
        date: "Juillet 2025",
        readTime: "8 min de lecture",
      },
      {
        cat: "Intelligence de rentabilité",
        title:
          "L'allocation de capital est un problème de données. La plupart des entreprises le règlent avec des opinions.",
        desc: "Où dépenser, où couper, où accélérer. Ce sont des questions de mesure, pas de stratégie. Les entreprises qui traitent l'allocation de capital comme un problème d'ingénierie de données surperforment systématiquement les autres.",
        date: "Juin 2025",
        readTime: "6 min de lecture",
      },
    ],
  },
  contact: {
    heroLabel: "Contact",
    heroTitle: "Décrivez le problème. Nous vous dirons si nous pouvons le résoudre.",
    heroSubtitle:
      "Soumettez votre demande ci-dessous. Nous répondons en un jour ouvrable avec une évaluation honnête de l'adéquation et une prochaine étape concrète.",
    howToReach: "Comment nous joindre",
    scopingCall: "Envoyez-nous votre demande.",
    scopingCallDesc:
      "Décrivez le système dont vous avez besoin, le défi de données que vous rencontrez ou la décision que vous voulez améliorer. Chaque soumission est lue par nous et reçoit une évaluation directe d'adéquation, de périmètre et de prochaine étape.",
    emailLabel: "Courriel",
    locationLabel: "Bureau",
    location: "Montréal, Canada",
    responseTimeLabel: "Temps de réponse",
    responseTime: "Un jour ouvrable",
    formName: "Nom",
    formNamePlaceholder: "Votre nom",
    formCompany: "Entreprise",
    formCompanyPlaceholder: "Nom de l'entreprise",
    formEmail: "Courriel",
    formEmailPlaceholder: "vous@entreprise.com",
    formMessage: "Qu'avez-vous besoin de construire?",
    formMessagePlaceholder:
      "Décrivez le flux, le défi de données ou la décision à améliorer. Plus c'est précis, plus notre réponse sera utile.",
    formSubmit: "Envoyer",
  },
  notFound: {
    title: "404",
    message: "Page introuvable.",
    backHome: "Retour à l'accueil",
  },
  footer: {
    tagline: "Systèmes IA, données et décision de calibre production. Conçus et déployés depuis le Canada.",
    engagements: "Mandats",
    company: "La firme",
    contactLabel: "Contact",
    copyright: "Vert AI Inc.",
    bottomTagline: "IA, Données et Systèmes décisionnels · Canada",
  },
  solutionsHub: {
    heroLabel: "Solutions",
    heroTitle: "Les systèmes qu'on construit. Les problèmes qu'on résout.",
    heroSubtitle:
      "Explorez les catégories de systèmes IA, données et décision que Vert AI conçoit, construit et déploie.",
    primaryLabel: "Catégories de solutions",
    primaryTitle: "Explorer par problème.",
    primarySubtitle:
      "Chaque catégorie représente une classe distincte de système qu'on construit. Cliquez pour explorer le problème, ce qu'on livre et le mandat qui convient.",
    secondaryLabel: "Capacités additionnelles",
    secondaryTitle: "Domaines de soutien.",
    recommendationTitle: "Recommandation et personnalisation",
    recommendationDesc:
      "Moteurs de recommandation et logique de prochaine meilleure action pour le commerce en ligne, le merchandising et l'expérience client.",
    recommendationVia: "Via IA prédictive",
    profitabilityGrowthTitle: "Décisions de rentabilité et de croissance",
    profitabilityGrowthDesc:
      "Systèmes de mesure et de modélisation reliant canal, cohorte et délai de récupération pour l'allocation de capital.",
    profitabilityGrowthVia: "Via IA prédictive",
    aiOpsTitle: "Opérations IA et contrôle",
    aiOpsDesc:
      "Monitoring, assurance qualité, évaluation, logique d'escalade et garde-fous pour les systèmes IA en production.",
    aiOpsVia: "Transversal · Post-lancement",
    bridgeLabel: "Comment engager",
    bridgeTitle: "Du problème au mandat.",
    bridgeDesc:
      "Chaque solution est livrée à travers un de nos quatre mandats structurés. Chaque mandat est cadré selon votre problème, tarifé selon la valeur attendue et porte une garantie de résultat concrète.",
    bridgeCta: "Voir les mandats",
    ctaHeadline: "Décrivez le problème.",
    ctaDesc: "Nous vous dirons ce qu'on construirait, quel mandat convient et ce que ça coûte.",
  },
  solutions: {
    aiAgents: {
      label: "Solution",
      heroTitle: "Agents IA et automatisation de flux",
      hubDesc:
        "Flux IA encadrés pour les opérations, la finance et l'exécution interne. Avec routage, contrôles et révision humaine.",
      heroSubtitle:
        "Flux IA encadrés qui automatisent des processus répétitifs à forte valeur. Routage, contrôles, chemins de repli et révision humaine aux points qui comptent.",
      problemLabel: "Le problème",
      problemTitle: "Des processus manuels qui ne passent pas l'échelle.",
      problemP1:
        "Des flux à forte valeur en opérations, finance et exécution interne sont encore exécutés à la main. Le volume monte. Les effectifs non. L'automatisation générique gère les cas simples et casse sur les exceptions, les cas limites et tout ce qui requiert du jugement.",
      problemP2:
        "Vert AI construit des agents IA qui traitent la routine, escaladent les exceptions et gardent les humains en contrôle là où ça compte.",
      gapsLabel: "Pourquoi les outils génériques échouent",
      gaps: "Incapables de raisonnement multi-étapes ou de logique conditionnelle|Aucun chemin de repli ni d'escalade quand la confiance baisse|Aucune intégration entre plusieurs systèmes internes|Aucune piste d'audit ni contrôle opérationnel|Cassent sur les cas limites qui exigent du jugement contextuel",
      buildsLabel: "Ce qu'on construit",
      buildsTitle: "Systèmes qu'on livre dans cette catégorie.",
      builds:
        "Agents IA multi-étapes pour flux opérationnels|Systèmes de routage et de triage avec scoring de confiance|Pipelines d'automatisation déclenchés par documents|Automatisation de flux finance et approvisionnement|Copilotes internes pour équipes fonctionnelles|Orchestration hybride règles et LLM|Logique de gestion d'exceptions et d'escalade|Interfaces de révision humaine dans la boucle",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où ça s'applique.",
      workflows:
        "Traitement et validation de factures|Gestion de commandes et exceptions|Vérification de conformité et revue documentaire|Automatisation de l'intégration des employés|Routage et triage de demandes internes|Automatisation des communications de chaîne d'approvisionnement|Préparation d'audits et collecte de preuves",
      humanLabel: "Supervision humaine",
      humanTitle: "Les humains restent dans la boucle.",
      humanDesc:
        "Chaque système d'agent inclut des seuils d'escalade configurables, des files de révision manuelle et des contrôles opérationnels. L'automatisation gère le volume. Les humains gèrent le jugement. Le système connaît la différence.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA agentique.",
      engagementDesc:
        "Cette solution est typiquement livrée via le mandat IA agentique, qui couvre le cadrage, l'architecture, l'implémentation, l'évaluation et le déploiement en production. Une seule équipe, du début à la fin.",
      engagementHref: "/services/agentic-ai",
      engagementCta: "En savoir plus sur IA agentique",
      ctaHeadline: "Décrivez le flux.",
      ctaDesc: "On cadrera le système, l'échéancier et les livrables.",
    },
    documentIntelligence: {
      label: "Solution",
      heroTitle: "Intelligence documentaire",
      hubDesc:
        "Extraction, classification et structuration à partir de contrats, factures, appels d'offres et flux documentaires à haute friction.",
      heroSubtitle:
        "Extraction, classification, validation et structuration de l'information à partir de contrats, propositions, factures, appels d'offres et autres flux documentaires à haute friction.",
      problemLabel: "Le problème",
      problemTitle: "Des documents qui emprisonnent la valeur.",
      problemP1:
        "L'information critique est enfermée dans des documents non structurés. Contrats, propositions, factures et dossiers réglementaires contiennent les données dont vos systèmes ont besoin, mais les extraire de façon fiable à grande échelle dépasse l'OCR générique et les outils par modèles.",
      problemP2:
        "Vert AI construit des systèmes d'intelligence documentaire qui extraient, classifient, valident et structurent l'information de documents complexes avec une fiabilité de production.",
      gapsLabel: "Pourquoi les outils génériques échouent",
      gaps: "L'extraction par modèle casse sur les variations de format|L'OCR seul ne comprend pas la sémantique|Aucune validation ni scoring de confiance|Ne cartographie pas les données vers les entités d'affaires|Aucune boucle de rétroaction pour l'amélioration continue",
      buildsLabel: "Ce qu'on construit",
      buildsTitle: "Systèmes qu'on livre dans cette catégorie.",
      builds:
        "Analyse de contrats et extraction de clauses|Systèmes de traitement et validation de factures|Automatisation de réponses aux appels d'offres|Classification de documents réglementaires|Traitement de réclamations d'assurance|Comparaison et scoring de propositions|Pipelines document vers base de données|Extraction multi-format avec scoring de confiance",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où ça s'applique.",
      workflows:
        "Revue de contrats d'approvisionnement|Automatisation des comptes fournisseurs|Analyse de documents juridiques|Traitement documentaire en souscription d'assurance|Classification de documents de conformité|Réception et scoring de propositions|Extraction de dépôts réglementaires",
      humanLabel: "Supervision humaine",
      humanTitle: "Les humains valident ce qui compte.",
      humanDesc:
        "Chaque système inclut des seuils de confiance, des files de révision manuelle pour les extractions à faible confiance et des règles de validation alignées sur la logique d'affaires. Le système gère le volume. Les humains gèrent les exceptions et les cas limites.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA générative.",
      engagementDesc:
        "Les solutions d'intelligence documentaire sont typiquement livrées via le mandat IA générative. Pour les organisations qui doivent aussi restructurer leur fondation de données, le mandat Plateformes de données peut s'appliquer.",
      engagementHref: "/services/generative-ai",
      engagementCta: "En savoir plus sur IA générative",
      ctaHeadline: "Montrez-nous les documents.",
      ctaDesc: "On cadrera le système d'extraction, les cibles de précision et le chemin de déploiement.",
    },
    knowledgeSystems: {
      label: "Solution",
      heroTitle: "Gestion du savoir et recherche d'entreprise",
      hubDesc:
        "Assistants internes qui récupèrent, raisonnent et rendent opérationnel le savoir institutionnel à travers l'organisation.",
      heroSubtitle:
        "Assistants internes qui récupèrent, raisonnent et rendent opérationnel le savoir institutionnel à travers les politiques, procédures, données produit et documentation commerciale.",
      problemLabel: "Le problème",
      problemTitle: "Du savoir qui existe mais qu'on ne trouve pas.",
      problemP1:
        "Votre organisation a les réponses. Elles sont dispersées dans des centaines de documents, wikis, procédures et systèmes hérités. Les employés perdent des heures à chercher de l'information qui devrait prendre quelques secondes. La recherche générique retourne des mots-clés, pas des réponses.",
      problemP2:
        "Vert AI construit des systèmes de savoir qui comprennent les questions, récupèrent le contexte pertinent, raisonnent à travers les sources et livrent des réponses actionnables avec citations.",
      gapsLabel: "Pourquoi la recherche classique échoue",
      gaps: "La recherche par mots-clés retourne des résultats, pas des réponses|Ne raisonne pas à travers plusieurs documents|Aucune compréhension du contexte organisationnel|Ne gère pas les questions de suivi ni les clarifications|Aucune attribution de source ni scoring de confiance",
      buildsLabel: "Ce qu'on construit",
      buildsTitle: "Systèmes qu'on livre dans cette catégorie.",
      builds:
        "Assistants de savoir d'entreprise avec architecture RAG|Systèmes de recherche de politiques et procédures|Recherche d'information produit pour ventes et support|Assistants de documentation technique|Agrégation de savoir multi-source|Interfaces conversationnelles avec attribution de source|Recherche contextuelle avec compréhension sémantique|Outils de curation et de maintenance de base de connaissances",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où ça s'applique.",
      workflows:
        "Questions sur les politiques RH et avantages|Recherche de savoir en support technique|Habilitation des ventes et information produit|Accès au savoir de conformité réglementaire|Livraison de savoir d'intégration et de formation|Consultation de procédures opérationnelles|Partage de savoir interservices",
      humanLabel: "Supervision humaine",
      humanTitle: "Une précision que vous pouvez vérifier.",
      humanDesc:
        "Chaque système de savoir inclut l'attribution de source, des indicateurs de confiance et des mécanismes de rétroaction. Les utilisateurs peuvent vérifier d'où viennent les réponses. Les administrateurs suivent la précision, identifient les lacunes et améliorent le système en continu.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA générative.",
      engagementDesc:
        "Les systèmes de savoir sont livrés via le mandat IA générative. La construction couvre la conception de l'architecture de recherche, le pipeline d'ingestion, la logique de raisonnement et le déploiement en production avec monitoring.",
      engagementHref: "/services/generative-ai",
      engagementCta: "En savoir plus sur IA générative",
      ctaHeadline: "Décrivez le problème de savoir.",
      ctaDesc: "On cadrera le système de recherche, les sources et le chemin de déploiement.",
    },
    customerSupport: {
      label: "Solution",
      heroTitle: "Service client et systèmes de soutien",
      hubDesc:
        "Systèmes IA qui résolvent les demandes, assistent les agents, classifient l'intention et accélèrent le service sans sacrifier la qualité.",
      heroSubtitle:
        "Systèmes IA qui résolvent les demandes répétitives, assistent les agents, classifient l'intention, remontent le bon savoir et accélèrent le service sans sacrifier la qualité ni la supervision.",
      problemLabel: "Le problème",
      problemTitle: "Un service qui ne passe pas l'échelle.",
      problemP1:
        "Le volume de billets monte. La capacité des agents non. Les questions répétitives consomment vos agents expérimentés. Les délais dérivent. La qualité devient incohérente. Les chatbots génériques ne traitent que les cas les plus simples et frustrent les clients dès qu'on dépasse la FAQ.",
      problemP2:
        "Vert AI construit des systèmes de soutien qui traitent la routine avec précision, assistent les agents sur les cas complexes et escaladent quand le jugement humain est requis.",
      gapsLabel: "Pourquoi les chatbots génériques échouent",
      gaps: "Ne traitent que les questions de type FAQ|Aucune intégration au savoir ou aux systèmes internes|Ne peuvent pas assister les agents sur les cas complexes|Aucune classification d'intention ni logique de routage|Aucun apprentissage à partir des patterns de résolution",
      buildsLabel: "Ce qu'on construit",
      buildsTitle: "Systèmes qu'on livre dans cette catégorie.",
      builds:
        "Triage et routage de billets par IA|Résolution automatisée des types de demandes courants|Assistance aux agents avec réponses suggérées|Classification d'intention et scoring de priorité|Génération de réponses ancrées dans le savoir|Logique d'escalade fondée sur la confiance|Détection de sentiment et d'urgence|Monitoring de qualité et boucles de rétroaction",
      workflowsLabel: "Flux typiques",
      workflowsTitle: "Où ça s'applique.",
      workflows:
        "Automatisation du soutien de niveau 1|Demandes de statut et de suivi de commande|Traitement des retours et échanges|Questions de compte et de facturation|Demandes d'information produit|Planification et coordination de services|Classification et routage de plaintes",
      humanLabel: "Supervision humaine",
      humanTitle: "Les agents gardent le contrôle.",
      humanDesc:
        "Chaque système de soutien inclut des limites d'automatisation configurables, le remplacement par l'agent et des seuils d'escalade. L'IA gère le volume et la cohérence. Les agents gèrent la complexité et l'empathie. Le système route intelligemment entre les deux.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA agentique.",
      engagementDesc:
        "Les systèmes de service client sont livrés via le mandat IA agentique. Le périmètre inclut la modélisation d'intention, l'intégration du savoir, les interfaces d'assistance aux agents et le déploiement en production avec monitoring de qualité.",
      engagementHref: "/services/agentic-ai",
      engagementCta: "En savoir plus sur IA agentique",
      ctaHeadline: "Décrivez le défi de soutien.",
      ctaDesc: "On cadrera le système, les limites d'automatisation et le chemin de déploiement.",
    },
    predictiveModels: {
      label: "Solution",
      heroTitle: "Modèles prédictifs et science décisionnelle",
      hubDesc:
        "Modèles sur mesure pour l'attrition, la valeur client, le scoring et la prévision. Conçus pour scorer, classer et guider l'action en production.",
      heroSubtitle:
        "Modèles sur mesure pour l'attrition, la valeur client, le scoring de prospects, la prévision de demande, la priorisation et l'aide à la décision commerciale. Conçus pour scorer, classer et guider l'action en production.",
      problemLabel: "Le problème",
      problemTitle: "Des décisions guidées par l'instinct, pas par le signal.",
      problemP1:
        "La plupart des entreprises ont des tableaux de bord qui décrivent le passé. Très peu ont des systèmes qui prédisent ce qui s'en vient et recommandent quoi faire. Les modèles existants vivent dans des notebooks. Ils n'atteignent jamais les flux où les décisions se prennent.",
      problemP2:
        "Vert AI construit des modèles prédictifs qui mènent à l'action commerciale. Pas des graphiques. Pas des présentations. Des systèmes de scoring et de recommandation déployés.",
      gapsLabel: "Pourquoi les tableaux de bord échouent",
      gaps: "L'analyse descriptive ne prédit pas les résultats|Les modèles dans les notebooks n'atteignent pas la production|Aucune intégration aux flux opérationnels|Le scoring exige un déploiement temps réel ou quasi temps réel|Aucune boucle de rétroaction entre prédiction et résultat",
      buildsLabel: "Ce qu'on construit",
      buildsTitle: "Systèmes qu'on livre dans cette catégorie.",
      builds:
        "Modèles de prédiction et d'intervention d'attrition|Modélisation de la valeur client|Systèmes de scoring et de priorisation de prospects|Prévision de demande et d'inventaire|Support d'optimisation d'assortiment et de prix|Modèles de propension pour marketing et ventes|Scoring de qualité et segmentation client|Classification et priorisation opérationnelle",
      workflowsLabel: "Décisions typiques",
      workflowsTitle: "Décisions qu'on améliore.",
      workflows:
        "Quels clients risquent le plus de partir|Où allouer l'effort commercial|Quels niveaux d'inventaire maintenir|Quels prospects prioriser|Comment segmenter les clients par valeur|Où ajuster les prix|Dans quelles cohortes marketing investir",
      humanLabel: "Aide à la décision, pas remplacement",
      humanTitle: "Les modèles informent. Les humains décident.",
      humanDesc:
        "Chaque modèle est construit avec interprétabilité, scoring de confiance et un cadre d'action clair. Le système fournit le signal. Votre équipe applique le jugement. Les seuils de décision sont configurables et transparents.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via IA prédictive.",
      engagementDesc:
        "Les solutions de modèles prédictifs et de science décisionnelle sont livrées via le mandat IA prédictive, qui couvre le cadrage de la décision, la conception du modèle, l'entraînement, l'évaluation, le déploiement et l'interprétation d'affaires.",
      engagementHref: "/services/predictive-ai",
      engagementCta: "En savoir plus sur IA prédictive",
      ctaHeadline: "Nommez la décision.",
      ctaDesc: "On cadrera le modèle, les exigences de données et le chemin de déploiement.",
    },
    dataPlatforms: {
      label: "Solution",
      heroTitle: "Plateformes de données pour l'IA",
      hubDesc:
        "Couches source de vérité, sémantiques et d'assurance qualité requises pour une IA fiable et des analyses cohérentes en production.",
      heroSubtitle:
        "Les couches source de vérité, sémantiques et d'assurance qualité requises pour une IA fiable, des analyses cohérentes et un déploiement de modèles en production. Conçues pour la confiance et la traçabilité.",
      problemLabel: "Le problème",
      problemTitle: "L'IA ne peut pas opérer sur des données peu fiables.",
      problemP1:
        "Les investissements en IA et en analyses s'effondrent quand les données sous-jacentes sont fragmentées, incohérentes ou peu fiables. Les modèles entraînés sur des entrées peu fiables produisent des décisions peu fiables. Les rapports bâtis sur une logique incohérente érodent la confiance plus vite qu'ils ne la construisent.",
      problemP2:
        "Vert AI construit la fondation de données dont vos systèmes IA et décisionnels ont besoin avant de pouvoir opérer de façon fiable.",
      gapsLabel: "Pourquoi les architectures de données existantes échouent",
      gaps: "Sources fragmentées sans source de vérité unique|Définitions de métriques incohérentes entre les équipes|Aucune couche sémantique pour les entrées de modèles IA|Contrôles de qualité et de confiance manquants|Fragilité des pipelines et manque de traçabilité",
      buildsLabel: "Ce qu'on construit",
      buildsTitle: "Systèmes qu'on livre dans cette catégorie.",
      builds:
        "Architecture de données source de vérité|Couche sémantique et définitions de métriques|Contrôles de qualité et de confiance|Instrumentation événementielle et traçabilité|Couches de préparation IA et ML|Résolution d'entités et gestion d'identité|Ingénierie de fiabilité des pipelines|Cadres de documentation et de gouvernance",
      workflowsLabel: "Défis de données courants",
      workflowsTitle: "Problèmes qu'on résout.",
      workflows:
        "Les rapports donnent des réponses différentes selon qui les produit|Modèles IA entraînés sur des entrées incohérentes|Aucune source de vérité unique entre les systèmes|Instrumentation manquante pour les événements d'affaires clés|Problèmes de qualité de données qui bloquent le déploiement IA|Les équipes ne s'entendent pas sur les définitions de métriques|Échecs de pipeline sans traçabilité",
      humanLabel: "Conçu pour la confiance",
      humanTitle: "Des données sur lesquelles votre équipe peut compter.",
      humanDesc:
        "Chaque plateforme de données inclut documentation, règles de gouvernance, monitoring de qualité et cartographie claire des responsabilités. L'objectif n'est pas seulement des données propres. C'est des données fiables sur lesquelles votre organisation et votre pile IA peuvent s'appuyer.",
      engagementLabel: "Mandat typique",
      engagementTitle: "Livré via Plateformes de données.",
      engagementDesc:
        "Les solutions de plateforme de données sont livrées via le mandat Plateformes de données, qui couvre la cartographie des sources, la modélisation des données, les contrôles de qualité, l'instrumentation, la préparation IA et la documentation.",
      engagementHref: "/services/data-platforms",
      engagementCta: "En savoir plus sur Plateformes de données",
      ctaHeadline: "Commencez par les données.",
      ctaDesc: "On cadrera l'architecture et le chemin vers la fiabilité.",
    },
  },
  authority: {
    vetVendor: {
      label: "Guide stratégique",
      heroTitle: "Comment évaluer un fournisseur IA",
      heroSubtitle:
        "Un cadre décisionnel pour les opérateurs qui évaluent des partenaires d'implémentation IA. Quoi chercher, quoi éviter et comment distinguer la vraie capacité d'un marketing soigné.",
      readTime: "12 min de lecture · Référence permanente",
      thesisLabel: "Le vrai problème",
      thesisTitle: "La plupart des évaluations de fournisseurs IA passent à côté de l'essentiel.",
      thesisP1:
        "Les entreprises qui évaluent des fournisseurs IA se concentrent sur les références, les études de cas et les prix. C'est utile mais insuffisant. Les variables qui déterminent le succès ou l'échec d'un projet IA portent presque entièrement sur la capacité d'ingénierie, l'évaluation de la maturité des données, la préparation à la production et le support post-déploiement.",
      thesisP2:
        "Ce guide fournit un cadre pratique pour distinguer les fournisseurs capables de livrer des systèmes en production de ceux qui livrent des présentations.",
      sectionsLabel: "Cadre d'évaluation",
      sectionsTitle: "Quoi évaluer.",
      sections:
        "Historique de production|Profondeur technique contre étendue|Capacité d'évaluation des données|Modèle de déploiement et de transfert|Transparence des prix et du périmètre|Structure de support post-lancement",
      sectionDescs:
        "Demandez des systèmes qui roulent en production aujourd'hui. Les démos et les preuves de concept ne sont pas des preuves de capacité de livraison.|Les spécialistes qui approfondissent un nombre limité de problèmes surpassent les généralistes qui prétendent tout faire. Posez des questions sur les décisions d'architecture, pas seulement sur les résultats.|Un fournisseur solide évalue la maturité de vos données avant de s'engager sur un échéancier. Les fournisseurs faibles sautent cette étape et blâment les données plus tard.|Comment le système se rend-il en production ? Qui le maintient ? Si la réponse est floue, le projet bloquera au déploiement.|Un périmètre fixe avec livrables définis surpasse les forfaits ouverts. Demandez des garanties de résultat.|Les systèmes IA exigent monitoring, réentraînement et raffinement. Demandez ce qui se passe après le lancement.",
      takeawaysLabel: "Signaux clés",
      takeawaysTitle: "Ce qui distingue les bons fournisseurs des mauvais.",
      takeaways:
        "Ils cadrent avant de vendre|Ils évaluent la maturité des données avant de s'engager sur un échéancier|Ils construisent pour la production, pas pour les démos|Ils garantissent des résultats, pas seulement de l'effort|Ils expliquent les compromis honnêtement|Ils ont un modèle post-lancement clair|Ils ne sous-traitent pas l'ingénierie cœur",
      perspectiveLabel: "La perspective Vert AI",
      perspectiveTitle: "On a bâti Vert AI pour réussir ce test.",
      perspectiveDesc:
        "Chaque mandat a des livrables définis, une garantie de résultat et un point de contact unique du cadrage à la production. Aucun sous-traitant. Aucun transfert. Aucune ambiguïté sur ce qui sera livré.",
      relatedLabel: "Explorer davantage",
      relatedTitle: "Solutions et ressources connexes.",
      relatedSolutions: "Ce que veut vraiment dire l'IA de production|Mandat IA agentique|Toutes les solutions",
      relatedHrefs: "/insights/production-grade-ai|/services/agentic-ai|/solutions",
      ctaHeadline: "Vous évaluez des partenaires IA?",
      ctaDesc:
        "Discutons de vos exigences. On vous donnera une évaluation honnête d'adéquation et de ce à quoi ressemble un mandat prêt pour la production.",
    },
    productionGrade: {
      label: "Référence technique",
      heroTitle: "Ce que veut vraiment dire « IA de calibre production »",
      heroSubtitle:
        "Une définition technique pour les opérateurs et décideurs. Ce qui sépare une démo fonctionnelle d'un système qui roule de façon fiable à l'intérieur d'une entreprise.",
      readTime: "10 min de lecture · Référence permanente",
      thesisLabel: "L'écart de définition",
      thesisTitle: "Tout le monde dit « calibre production ». Peu le livrent.",
      thesisP1:
        "Le terme « calibre production » a été dilué par la surutilisation. Les fournisseurs s'en servent pour décrire n'importe quoi, du notebook Jupyter avec une interface Streamlit jusqu'à un système entièrement monitoré, tolérant aux pannes et accompagné de documentation opérationnelle. Pour les acheteurs, cette ambiguïté coûte cher.",
      thesisP2:
        "Cette page définit ce que le calibre production exige réellement, pourquoi la plupart des projets IA n'y arrivent pas et quoi chercher chez un partenaire capable de le livrer.",
      sectionsLabel: "Exigences de production",
      sectionsTitle: "Ce que le calibre production exige.",
      sections:
        "Fiabilité et tolérance aux pannes|Monitoring et observabilité|Intégrité des pipelines de données|Sécurité et contrôles d'accès|Documentation et transfert|Modèle de support opérationnel",
      sectionDescs:
        "Le système gère les erreurs gracieusement, réessaie intelligemment et se dégrade sans défaillance catastrophique. Il roule sur déclencheurs ou planificateurs, pas par exécution manuelle.|Métriques de performance, scores de qualité, détection de dérive et alertes. Vous savez quand le système se dégrade avant vos utilisateurs.|Les données d'entrée sont validées, versionnées et traçables. Le système sait quand ses entrées changent d'une façon qui affecte la qualité de sortie.|Accès par rôle, pistes d'audit et architecture conforme. Pas des ajouts de dernière minute juste avant le lancement.|Documentation technique complète, procédures opérationnelles et habilitation de l'équipe. Le système est transférable, pas dépendant de celui qui l'a construit.|Monitoring, réentraînement, raffinement et support de feuille de route. La production est le début du cycle de vie du système, pas la fin.",
      takeawaysLabel: "Liste de vérification diagnostique",
      takeawaysTitle: "Votre système IA est-il de calibre production?",
      takeaways:
        "Il roule sans intervention manuelle|Il gère les erreurs et les cas limites gracieusement|Il est monitoré avec des alertes claires|Ses données d'entrée sont validées et traçables|Il a une documentation complète|Il a une propriété opérationnelle définie|Il a un plan de réentraînement et de raffinement|Il respecte les exigences de sécurité et de conformité",
      perspectiveLabel: "Le standard Vert AI",
      perspectiveTitle: "Chaque système qu'on construit atteint cette barre.",
      perspectiveDesc:
        "On ne livre pas de prototypes. Chaque mandat se termine par un système déployé, monitoré et documenté avec transfert opérationnel. Si on ne peut pas livrer au standard de production, on continue sans frais professionnels jusqu'à livraison.",
      relatedLabel: "Explorer davantage",
      relatedTitle: "Solutions et ressources connexes.",
      relatedSolutions: "Mandat IA agentique|Agents IA et automatisation de flux|Plateformes de données pour l'IA",
      relatedHrefs: "/services/agentic-ai|/solutions/ai-agents-workflow-automation|/solutions/data-platforms-for-ai",
      ctaHeadline: "Besoin d'un système de calibre production?",
      ctaDesc:
        "Décrivez le flux. On cadrera le système, le chemin de déploiement et les exigences de production.",
    },
    workflowsDeserveAI: {
      label: "Cadre décisionnel",
      heroTitle: "Quels flux méritent l'IA — et lesquels non",
      heroSubtitle:
        "Tous les processus n'ont pas besoin d'IA. Un cadre pratique pour identifier où l'IA crée une vraie valeur et où elle crée une complexité coûteuse.",
      readTime: "9 min de lecture · Référence permanente",
      thesisLabel: "Le problème de sélection",
      thesisTitle: "La plupart des entreprises automatisent les mauvais flux en premier.",
      thesisP1:
        "La pression d'adopter l'IA pousse les entreprises à l'appliquer partout sans évaluer où elle crée vraiment de la valeur. Le résultat : un portefeuille de pilotes coûteux qui résolvent des problèmes que personne n'a priorisés et qui ignorent les flux qui généreraient le meilleur rendement.",
      thesisP2:
        "Ce cadre aide les opérateurs à identifier quels flux méritent un investissement IA, lesquels méritent une automatisation plus simple et lesquels devraient rester manuels.",
      sectionsLabel: "Critères d'évaluation",
      sectionsTitle: "Comment évaluer l'adéquation flux-IA.",
      sections:
        "Volume et répétition|Complexité décisionnelle|Disponibilité des données|Coût et tolérance aux erreurs|Exigences d'intégration|Clarté de la mesure",
      sectionDescs:
        "Les flux à fort volume et répétitifs avec patterns constants sont les meilleurs candidats. Les flux à faible volume et hautement variables justifient rarement l'investissement IA.|Les flux qui exigent du raisonnement multi-étapes, du jugement contextuel ou de la reconnaissance de patterns bénéficient de l'IA. Les flux à règles simples sont mieux servis par l'automatisation traditionnelle.|L'IA exige des données structurées, accessibles et suffisamment riches. Si les données n'existent pas ou exigent un nettoyage massif, commencez par la plateforme de données.|Les flux où les erreurs sont coûteuses mais détectables sont de bons candidats. Les flux où les erreurs sont catastrophiques et indétectables exigent une prudence extrême.|Les flux qui opèrent en isolation sont plus faciles à automatiser. Les flux profondément intégrés à des systèmes complexes exigent plus de planification architecturale.|Si vous ne pouvez pas mesurer l'amélioration, vous ne pouvez pas justifier l'investissement. Métriques de référence claires et critères de succès sont des prérequis.",
      takeawaysLabel: "Signaux de décision",
      takeawaysTitle: "Quand investir dans l'IA.",
      takeaways:
        "Le flux est à fort volume et répétitif|Les données existent et sont raisonnablement structurées|Le coût des erreurs est gérable avec supervision humaine|L'amélioration est mesurable en termes d'affaires|Le flux a des limites et des points de transfert clairs|Le logiciel standard ne peut pas gérer la complexité|L'équipe est prête à adopter et à opérer le système",
      perspectiveLabel: "L'approche Vert AI",
      perspectiveTitle: "On commence par le flux, pas par la technologie.",
      perspectiveDesc:
        "Chaque mandat commence par la sélection du flux et le cadrage d'affaires. On aide les clients à identifier les meilleures cibles d'automatisation avant de s'engager dans une construction. Si l'IA n'est pas la bonne réponse, on le dit.",
      relatedLabel: "Explorer davantage",
      relatedTitle: "Solutions et ressources connexes.",
      relatedSolutions:
        "Agents IA et automatisation de flux|Intelligence documentaire|Service client et systèmes de soutien|Toutes les solutions",
      relatedHrefs:
        "/solutions/ai-agents-workflow-automation|/solutions/document-intelligence|/solutions/customer-support-service-systems|/solutions",
      ctaHeadline: "Pas certain où l'IA s'applique?",
      ctaDesc:
        "Décrivez vos flux. On vous aidera à identifier où l'IA crée une vraie valeur et où elle n'en crée pas.",
    },
  },
  industriesHub: {
    heroLabel: "Industries",
    heroTitle: "Des systèmes IA conçus pour votre industrie.",
    heroSubtitle:
      "Systèmes IA, données et décision de calibre production, conçus pour les flux et les contraintes spécifiques de votre secteur.",
    listLabel: "Secteurs servis",
    listTitle: "Systèmes par industrie.",
    listSubtitle:
      "On construit des systèmes IA et données pour les industries où le logiciel standard s'arrête et où les implantations ratées coûtent cher.",
    bridgeLabel: "Capacités transversales",
    bridgeTitle: "Même rigueur. Contexte différent.",
    bridgeDesc:
      "Chaque mandat industriel s'appuie sur les mêmes solutions et le même modèle de livraison. L'architecture, les patterns de données et les exigences opérationnelles changent. Le standard d'ingénierie, lui, ne change pas.",
    ctaHeadline: "Parlez-nous de votre industrie.",
    ctaDesc:
      "On cadrera le système autour de vos flux spécifiques, vos contraintes et votre environnement de données.",
  },
  industries: {
    accounting: {
      label: "Industrie",
      heroTitle: "Systèmes IA pour cabinets comptables",
      hubDesc:
        "Traitement documentaire, recherche de savoir et automatisation de flux conçus pour les exigences de conformité, de précision et de piste d'audit des cabinets comptables.",
      heroSubtitle:
        "Systèmes IA de calibre production pour le traitement documentaire, la recherche de savoir, la communication client et l'automatisation de flux. Conçus pour les exigences de conformité, de précision et de piste d'audit de la comptabilité professionnelle.",
      painsLabel: "Le défi",
      painsTitle: "Là où le logiciel standard s'arrête.",
      painsP1:
        "Les cabinets comptables traitent d'énormes volumes de documents structurés et non structurés, des demandes clients répétitives et des exigences de conformité complexes. Les logiciels de gestion de cabinet gèrent la planification et la facturation mais ne peuvent pas automatiser le travail intensif en savoir qui consomme le temps des associés.",
      painsP2:
        "Les systèmes IA pour les flux comptables doivent respecter des exigences de précision, de conformité et de piste d'audit que l'automatisation générique ne peut pas satisfaire.",
      painsListLabel: "Points de friction courants",
      pains:
        "Traitement manuel de documents pour déclarations fiscales et états financiers|Demandes clients répétitives qui consomment le temps des associés|Savoir emprisonné dans l'expertise des associés et la mémoire institutionnelle|Vérifications de conformité qui reposent sur le savoir individuel|Qualité de travail incohérente entre les membres de l'équipe|Contraintes de capacité saisonnière sans solution évolutive",
      systemsLabel: "Ce qu'on construit",
      systemsTitle: "Systèmes pour les flux comptables.",
      systems:
        "Extraction de données de formulaires fiscaux et d'états financiers|Automatisation des demandes clients avec réponses conformes|Systèmes de recherche pour le code fiscal et la réglementation|Automatisation de lettres de mission et de propositions|Systèmes de revue et d'assurance qualité des papiers de travail|Assistants de savoir interne pour la formation et la consultation",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions:
        "Intelligence documentaire|Gestion du savoir et recherche d'entreprise|Agents IA et automatisation de flux|Service client et systèmes de soutien",
      solutionHrefs:
        "/solutions/document-intelligence|/solutions/knowledge-systems-enterprise-retrieval|/solutions/ai-agents-workflow-automation|/solutions/customer-support-service-systems",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour les cabinets comptables.",
      engagementDesc:
        "La plupart des mandats pour cabinets comptables sont livrés via IA agentique pour l'automatisation de flux, IA générative pour l'intelligence documentaire, ou Plateformes de données quand la fondation de données doit être restructurée d'abord.",
      engagements: "IA agentique|Plateformes de données",
      engagementHrefs: "/services/agentic-ai|/services/data-platforms",
      ctaHeadline: "Décrivez le flux.",
      ctaDesc:
        "On cadrera le système autour des exigences spécifiques de votre cabinet, de ses contraintes de conformité et de ses défis de capacité.",
    },
    manufacturing: {
      label: "Industrie",
      heroTitle: "IA pour manufacturiers et distributeurs",
      hubDesc:
        "Prévision de demande, automatisation de chaîne d'approvisionnement et intelligence opérationnelle conçues pour les flux manufacturiers et de distribution.",
      heroSubtitle:
        "Systèmes IA de calibre production pour la prévision de demande, l'optimisation d'inventaire, la communication fournisseur et la prise de décision opérationnelle. Conçus pour la complexité et l'échelle du manufacturier et de la distribution.",
      painsLabel: "Le défi",
      painsTitle: "Là où les ERP et outils de planification s'arrêtent.",
      painsP1:
        "Les manufacturiers et distributeurs opèrent avec des chaînes d'approvisionnement complexes, des patrons de demande volatils et des marges minces. Les ERP gèrent les transactions mais ne peuvent ni prédire les changements de demande, ni optimiser l'allocation d'inventaire, ni automatiser les communications qui relient fournisseurs, entrepôts et clients.",
      painsP2:
        "Les systèmes IA pour le manufacturier doivent s'intégrer aux ERP et WMS existants, traiter des données opérationnelles imparfaites et livrer des recommandations sur lesquelles les contremaîtres et planificateurs peuvent agir.",
      painsListLabel: "Points de friction opérationnels",
      pains:
        "Prévision de demande qui repose sur des tableurs et de l'intuition|Décisions d'allocation d'inventaire qui ignorent les signaux temps réel|Communication fournisseur et gestion de commandes manuelles|Contrôle qualité qui détecte les problèmes après la production|Données déconnectées entre ERP, WMS et outils de planification|Aucun support décisionnel pour le prix, l'assortiment ou le timing d'approvisionnement",
      systemsLabel: "Ce qu'on construit",
      systemsTitle: "Systèmes pour le manufacturier et la distribution.",
      systems:
        "Modèles de prévision de demande et d'optimisation d'inventaire|Automatisation de communication fournisseur et de commandes|Prédiction de qualité et classification de défauts|Support d'optimisation de planification de production|Intelligence de timing d'approvisionnement et de prix|Tableaux de bord opérationnels avec données de calibre décisionnel",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions: "Modèles prédictifs et science décisionnelle|Agents IA et automatisation de flux|Plateformes de données pour l'IA",
      solutionHrefs:
        "/solutions/predictive-models-decision-science|/solutions/ai-agents-workflow-automation|/solutions/data-platforms-for-ai",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour les manufacturiers.",
      engagementDesc:
        "Les mandats manufacturiers impliquent typiquement IA prédictive pour la prévision et l'optimisation, IA agentique pour l'automatisation de flux, et Plateformes de données quand la fondation de données doit être travaillée d'abord.",
      engagements: "IA prédictive|IA agentique|Plateformes de données",
      engagementHrefs: "/services/predictive-ai|/services/agentic-ai|/services/data-platforms",
      ctaHeadline: "Décrivez l'opération.",
      ctaDesc:
        "On cadrera le système autour de votre chaîne d'approvisionnement, de votre flux de production ou de votre défi de données.",
    },
    services: {
      label: "Industrie",
      heroTitle: "IA pour entreprises de services et métiers",
      hubDesc:
        "Automatisation de flux, intelligence de planification et systèmes de communication client conçus pour les opérations de services à fort volume.",
      heroSubtitle:
        "Systèmes IA de calibre production pour la prise en charge client, l'optimisation de planification, la communication de service et l'automatisation opérationnelle. Conçus pour les exigences de vitesse et de fiabilité des entreprises de services.",
      painsLabel: "Le défi",
      painsTitle: "Là où le logiciel de gestion de services s'arrête.",
      painsP1:
        "Les entreprises de services et les métiers traitent de forts volumes de demandes clients, de la complexité de planification et beaucoup de communication. Les CRM et outils de service terrain gèrent les contacts et les rendez-vous mais ne peuvent pas automatiser les flux de prise en charge, de triage et de communication qui consomment le temps des répartiteurs et coordonnateurs.",
      painsP2:
        "Les systèmes IA pour les entreprises de services doivent être rapides, fiables et assez simples pour que les équipes terrain les utilisent sans formation.",
      painsListLabel: "Points de friction opérationnels",
      pains:
        "Prise en charge et triage qui dépendent d'appels et de courriels|Planification qui ne peut pas optimiser route, compétence et priorité|Communication client répétitive qui consomme le personnel de bureau|Aucun suivi systématique ni monitoring de qualité de service|Savoir emprisonné chez les techniciens et répartiteurs seniors|Soumissions et estimations qui reposent sur l'expérience individuelle",
      systemsLabel: "Ce qu'on construit",
      systemsTitle: "Systèmes pour les opérations de services.",
      systems:
        "Automatisation de la prise en charge client avec triage intelligent|Optimisation de planification avec route et compétences|Communication de service automatisée et suivi|Recherche de savoir pour techniciens terrain|Systèmes de support à la soumission et à l'estimation|Monitoring de qualité de service et boucles de rétroaction",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions:
        "Agents IA et automatisation de flux|Service client et systèmes de soutien|Gestion du savoir et recherche d'entreprise",
      solutionHrefs:
        "/solutions/ai-agents-workflow-automation|/solutions/customer-support-service-systems|/solutions/knowledge-systems-enterprise-retrieval",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour les entreprises de services.",
      engagementDesc:
        "Les mandats pour entreprises de services sont typiquement livrés via IA agentique pour l'automatisation de flux et IA générative pour le savoir de communication client.",
      engagements: "IA agentique",
      engagementHrefs: "/services/agentic-ai",
      ctaHeadline: "Décrivez le flux de service.",
      ctaDesc:
        "On cadrera le système autour de votre défi de prise en charge, de planification ou de communication.",
    },
    ecommerce: {
      label: "Industrie",
      heroTitle: "IA pour les opérations de commerce en ligne",
      hubDesc:
        "Intelligence client, optimisation de catalogue et mesure de rentabilité conçues pour le commerce DTC et le détail à l'échelle.",
      heroSubtitle:
        "Systèmes IA de calibre production pour l'intelligence client, l'optimisation de catalogue, l'automatisation du soutien et la mesure de rentabilité. Conçus pour la vitesse et la complexité des opérations de commerce en ligne modernes.",
      painsLabel: "Le défi",
      painsTitle: "Là où les plateformes de commerce s'arrêtent.",
      painsP1:
        "Les opérations de commerce en ligne génèrent d'énormes volumes de données entre comportement client, catalogues, canaux marketing et exécution. Les outils de plateforme gèrent les transactions et les analyses de base mais ne peuvent pas bâtir l'intelligence client, les modèles prédictifs et les systèmes décisionnels qui alimentent une croissance rentable à l'échelle.",
      painsP2:
        "Les systèmes IA pour le commerce en ligne doivent s'intégrer aux plateformes existantes, traiter des données temps réel et livrer des recommandations sur lesquelles les équipes merchandising et marketing peuvent agir immédiatement.",
      painsListLabel: "Points de friction opérationnels",
      pains:
        "Coûts d'acquisition en hausse sans visibilité sur la qualité par canal|Décisions merchandising fondées sur le revenu, pas la marge de contribution|Volume de soutien qui croît plus vite que la capacité d'équipe|Aucun modèle prédictif pour l'attrition, la valeur client ou la demande|Optimisation de catalogue qui repose sur la curation manuelle|Attribution et mesure qui se contredisent entre plateformes",
      systemsLabel: "Ce qu'on construit",
      systemsTitle: "Systèmes pour les opérations de commerce en ligne.",
      systems:
        "Modèles de valeur client et de prédiction d'attrition|Mesure de rentabilité par canal, cohorte et produit|Automatisation du soutien avec intégration du savoir produit|Moteurs de recommandation et de personnalisation|Prévision de demande et optimisation d'inventaire|Enrichissement de catalogue et optimisation de recherche",
      solutionsLabel: "Solutions pertinentes",
      solutionsTitle: "Explorer par catégorie de système.",
      solutions: "Modèles prédictifs et science décisionnelle|Service client et systèmes de soutien|Plateformes de données pour l'IA",
      solutionHrefs:
        "/solutions/predictive-models-decision-science|/solutions/customer-support-service-systems|/solutions/data-platforms-for-ai",
      engagementLabel: "Mandats typiques",
      engagementTitle: "Comment on livre pour le commerce en ligne.",
      engagementDesc:
        "Les mandats commerce en ligne couvrent typiquement plusieurs piliers : IA prédictive pour la prévision, la recommandation et la mesure de rentabilité ; IA agentique pour le soutien et l'automatisation de catalogue ; et Plateformes de données quand la fondation de données doit être travaillée.",
      engagements: "IA prédictive|Plateformes de données|IA agentique",
      engagementHrefs: "/services/predictive-ai|/services/data-platforms|/services/agentic-ai",
      ctaHeadline: "Décrivez le défi commerce.",
      ctaDesc:
        "On cadrera le système autour de votre problème de croissance, de mesure ou d'opérations.",
    },
  },
  seo: {
    home: {
      title: "Conseil en IA au Canada — Systèmes IA de production | Vert AI",
      description: "Vert AI conçoit, construit et déploie des systèmes IA, des plateformes de données et des moteurs décisionnels de calibre production. Une équipe, du cadrage au déploiement.",
      keywords: "conseil IA Canada, IA production, systèmes IA, plateformes de données, science décisionnelle, ingénierie ML",
    },
    services: {
      title: "Mandats IA — Agentique, générative, prédictive et données | Vert AI",
      description: "Quatre mandats IA de calibre production : IA agentique, IA générative, IA prédictive et plateformes de données. Cadrés et déployés de bout en bout.",
      keywords: "mandats IA, IA agentique, IA générative, IA prédictive, plateformes de données",
    },
    agenticAI: {
      title: "IA agentique — Automatisation de processus | Vert AI",
      description: "Agents IA bornés avec routage, contrôles, plans de repli et supervision humaine. Automatisez les processus à fort volume avec des systèmes agentiques opérationnels.",
      keywords: "IA agentique, agents IA, automatisation processus, agents autonomes, supervision humaine",
    },
    generativeAI: {
      title: "IA générative et systèmes de récupération | Vert AI",
      description: "IA générative ancrée dans la récupération avec attribution des sources, évaluation et seuils de précision. Transformez vos connaissances en réponses fiables.",
      keywords: "IA générative, RAG, récupération augmentée, IA entreprise, systèmes de connaissance",
    },
    predictiveAI: {
      title: "IA prédictive — Modèles ML en production | Vert AI",
      description: "Modèles ML en production pour l'attrition, la valeur à vie, la demande, la recommandation et la rentabilité. Déployés dans les processus où les décisions se prennent.",
      keywords: "IA prédictive, apprentissage machine, prédiction attrition, prévision demande, recommandation",
    },
    dataPlatforms: {
      title: "Plateformes de données pour l'IA | Vert AI",
      description: "Architecture de référence, couche sémantique, contrôles qualité et instrumentation prête pour l'IA. La fondation dont dépend l'IA en production.",
      keywords: "plateformes de données, architecture données, couche sémantique, données IA, ingénierie données Canada",
    },
    solutions: {
      title: "Solutions IA — Systèmes de production par domaine | Vert AI",
      description: "Agents IA, intelligence documentaire, systèmes de connaissance, soutien client, modèles prédictifs et plateformes de données — construits et déployés par une seule équipe.",
      keywords: "solutions IA, cas d'usage IA, intelligence documentaire, systèmes connaissance, modèles prédictifs",
    },
    aiAgents: {
      title: "Agents IA et automatisation de processus | Vert AI",
      description: "Réduisez les coûts de traitement manuel avec des agents IA bornés. Logique de routage, contrôles, plans de repli et revue humaine aux points critiques.",
      keywords: "agents IA, automatisation processus, automatisation intelligente",
    },
    documentIntelligence: {
      title: "Intelligence documentaire et extraction | Vert AI",
      description: "IA documentaire de calibre production pour contrats, factures, formulaires et PDF non structurés. Extraction, classification et validation avec pistes d'audit.",
      keywords: "intelligence documentaire, IA documentaire, OCR, traitement documentaire intelligent",
    },
    knowledgeSystems: {
      title: "Systèmes de connaissance et récupération d'entreprise | Vert AI",
      description: "Assistants augmentés par récupération qui raisonnent sur vos politiques, procédures, données produit et documentation commerciale, avec attribution des sources.",
      keywords: "systèmes connaissance, recherche entreprise, RAG, IA connaissance interne",
    },
    customerSupport: {
      title: "IA pour le service à la clientèle | Vert AI",
      description: "Augmentez la vitesse de résolution et contenez le coût par requête. Classification d'intention, réponses ancrées, assistance agent et escalade par confiance.",
      keywords: "IA service client, automatisation service, assistance agent, déviation requêtes",
    },
    predictiveModels: {
      title: "Modèles prédictifs et science décisionnelle | Vert AI",
      description: "Modèles de production pour l'attrition, la valeur à vie, la demande, la recommandation et la rentabilité — câblés dans les processus où les décisions se prennent.",
      keywords: "modèles prédictifs, science décisionnelle, modèles ML, prévision demande",
    },
    dataPlatformsForAI: {
      title: "Plateformes de données pour l'IA en production | Vert AI",
      description: "Architecture de référence, couche sémantique, contrôles qualité et instrumentation prête pour l'IA. La fondation de données dont dépend votre IA.",
      keywords: "plateforme données, données prêtes IA, pile de données moderne, couche sémantique",
    },
    industries: {
      title: "Industries — Systèmes IA par secteur | Vert AI",
      description: "IA en production pour cabinets comptables, manufacturiers et distributeurs, services professionnels et opérations e-commerce au Canada et aux États-Unis.",
      keywords: "IA par industrie, conseil IA secteurs, solutions IA sectorielles",
    },
    accounting: {
      title: "IA pour cabinets comptables et de vérification | Vert AI",
      description: "Systèmes IA pour cabinets comptables et de vérification : intelligence documentaire, automatisation des feuilles de travail, accueil client et flux de revue.",
      keywords: "IA comptabilité, automatisation vérification, IA cabinet comptable, technologie CPA",
    },
    manufacturing: {
      title: "IA pour manufacturiers et distributeurs | Vert AI",
      description: "Prévision de la demande, planification de production, maintenance prédictive et optimisation de la chaîne d'approvisionnement. IA pour opérateurs industriels.",
      keywords: "IA manufacturier, IA distribution, prévision demande, maintenance prédictive, IA chaîne approvisionnement",
    },
    serviceBusinesses: {
      title: "IA pour cabinets de services professionnels | Vert AI",
      description: "Systèmes de connaissance, intelligence documentaire, automatisation de propositions et intelligence de mandat pour cabinets de services et de conseil.",
      keywords: "IA services professionnels, IA conseil, automatisation cabinet services",
    },
    ecommerce: {
      title: "IA pour le commerce en ligne et la croissance DTC | Vert AI",
      description: "Recommandation, prévision de la demande, mesure de rentabilité, automatisation du soutien et intelligence de catalogue pour opérateurs e-commerce et DTC.",
      keywords: "IA commerce en ligne, IA DTC, systèmes recommandation, automatisation e-commerce",
    },
    insights: {
      title: "Perspectives — Analyse stratégique IA et données | Vert AI",
      description: "Analyse de calibre opérationnel sur les systèmes IA, l'infrastructure de données et l'économie de la décision commerciale. Écrit pour opérateurs seniors.",
      keywords: "perspectives IA, stratégie IA, déploiement IA, analyse ingénierie données",
    },
    vetVendor: {
      title: "Comment évaluer un fournisseur IA — Guide acheteur | Vert AI",
      description: "Distinguez la vraie capacité IA du marketing soigné. Les questions, critères et signaux qui séparent les fournisseurs de production des boutiques de prototypes.",
      keywords: "évaluation fournisseur IA, achat IA, choisir consultant IA, guide acheteur IA",
    },
    productionGrade: {
      title: "Ce que signifie réellement « IA de production » | Vert AI",
      description: "Ce qui sépare une démo d'un système qui tourne en production. L'ingénierie, la surveillance, les plans de repli et la discipline opérationnelle requises.",
      keywords: "IA production, IA de calibre production, MLOps, déploiement IA",
    },
    workflowsDeserveAI: {
      title: "Quels processus méritent l'IA — Cadre de sélection | Vert AI",
      description: "Où l'IA crée de la valeur mesurable et où elle n'en crée pas. Un cadre diagnostique pour choisir les processus qui justifient l'investissement.",
      keywords: "sélection cas d'usage IA, ROI IA, critères automatisation, priorisation IA",
    },
    about: {
      title: "À propos — Conseil IA de production au Canada | Vert AI",
      description: "Vert AI est une firme de conseil IA fondée par Guillaume Belisle. On comble l'écart d'exécution entre la stratégie IA et les systèmes en production. Basée au Canada.",
      keywords: "à propos Vert AI, Guillaume Belisle, conseil IA Canada, firme deep-tech",
    },
    contact: {
      title: "Contact — Discutons de votre système IA | Vert AI",
      description: "Discutez avec Vert AI de votre opportunité IA, données ou décisionnelle. Contact direct avec l'équipe qui cadrera, construira et déploiera le système.",
      keywords: "contact Vert AI, contact conseil IA, mandat IA",
    },
    notFound: {
      title: "Page introuvable | Vert AI",
      description: "La page que vous cherchez n'existe pas ou a été déplacée.",
    },
    unsubscribe: {
      title: "Désabonnement | Vert AI",
      description: "Gérez vos préférences courriel.",
    },
  },
};

